import { createSelector } from '@ngrx/store';
import { selectDigitaixState } from '../core.selectors';

export const selectWindowState = createSelector(
  selectDigitaixState,
  state => state.windows,
);

export const getWindow = (windowId: string) => createSelector(
  selectWindowState,
  state => state[windowId] || null
);

export const getWindowHeight = (windowId: string) => createSelector(
  getWindow(windowId),
  window => window && window.height,
);

export const getWindowWidth = (windowId: string) => createSelector(
  getWindow(windowId),
  window => window && window.width,
);

export const getWindowDraggable = (windowId: string) => createSelector(
  getWindow(windowId),
  window => window && window.draggable,
);

export const getWindowResizsable = (windowId: string) => createSelector(
  getWindow(windowId),
  window => window && window.resizable,
);

export const getWindowMinimized = (windowId: string) => createSelector(
  getWindow(windowId),
  window => window && window.minimized,
);

export const getWindowTitle = (windowId: string) => createSelector(
  getWindow(windowId),
  window => window && window.title,
);

export const getWindowIcon = (windowId: string) => createSelector(
  getWindow(windowId),
  window => window && window.icon,
);

export const getAllWindows = createSelector(
  selectWindowState,
  state => Object.entries(state).map(([windowId, window]) => ({ id: windowId, ...window })),
);
